import React from "react";
import { all_routes } from "../../../router/all_routes";
import { Link, useLocation } from "react-router-dom";

const InstructorSettingsLink = () => {
    const route = all_routes;

    const location = useLocation();

  return (
    <>
      <ul className="settings-nav d-flex align-items-center flex-wrap border bg-light-900 rounded">
        <li>
          <Link to={route.adminSettingPassword} className={`${location.pathname === '/admin/settings' ? 'active' : ''}`}>Password</Link>
        </li>
        <li>
          <Link to={route.adminSettingMenu} className={`${location.pathname === '/admin/settings/main-menu' ? 'active' : ''}`}>Main Menu</Link>
        </li>
      </ul>
    </>
  );
};

export default InstructorSettingsLink;
